var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "funding-details-link" },
    [
      _c("ob1-liens-icone", {
        attrs: {
          mini: "",
          "is-button": "",
          icon: "icon-info-alt",
          title: _vm.text,
        },
        on: {
          click: function ($event) {
            return _vm.$emit("fundingDetailsClick", _vm.seoId)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }